import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class TaskTypeService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async getTaskTypes() {
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/TaskType",
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/taskTypeService.js